import React from 'react';

/** Header shown at the top of each control panel (e.g. "Bank Account Components"). */
export const sectionHeaderStyle: React.CSSProperties = { marginTop: 0, marginBottom: '1rem' };
